'use client';

import { useState } from 'react';
import { cn } from '../_lib/utils';
import { useMotionValueEvent, useScroll } from 'motion/react';
import { useGetPageCurrentScrollContainerRef } from '../LenisScroll';
import { Text } from '../Text';

type ScrollPromptProps = {
	className?: string;
	children?: React.ReactNode;
};

export function ScrollPrompt(props: ScrollPromptProps) {
	const [pageScrolled, setPageScrolled] = useState(false);

	const { scrollWrapperRef, scrollContentRef } = useGetPageCurrentScrollContainerRef();
	const { scrollY } = useScroll({ container: scrollWrapperRef, target: scrollContentRef, layoutEffect: false });

	useMotionValueEvent(scrollY, 'change', latest => {
		if (latest < 10) {
			setPageScrolled(false);
		} else {
			setPageScrolled(true);
		}
	});

	return (
		<div className={cn('fixed md:bottom-0 w-full', props.className)}>
			<div
				className={`flex flex-col items-center justify-center transition-opacity duration-fast ease-smooth opacity-0`}
				style={{ opacity: pageScrolled ? 0 : 1 }}
			>
				<Text className={`text-center uppercase`} styleType='label-sm'>
					{props.children}
				</Text>
				<div
					className={`h-14 origin-top-left transition-transform duration-fast ease-smooth mt-4`}
					style={{ transform: pageScrolled ? 'scaleY(0)' : 'scaleY(1)' }}
				>
					<div className={`w-px h-14 bg-linear-to-b from-text-primary to-text-primary/0`} />
				</div>
			</div>
		</div>
	);
}
